import { validateCard, validateCardType } from './validate-card';

const renderIcon = (cardNumber: string) => {
  const CardBank = validateCard(cardNumber);

  if (CardBank) {
    return <div>{CardBank}</div>;
  }

  const CardType = validateCardType(cardNumber);

  if (CardType) {
    return <CardType />;
  }

  return null;
};

const renderBankIcon = (cardNumber: string) => {
  const CardBank = validateCard(cardNumber);

  if (CardBank) {
    return <div>{CardBank}</div>;
  }

  return <div />;
};

const renderCardTypeIcon = (cardNumber: string) => {
  const CardType = validateCardType(cardNumber);

  if (CardType) {
    return <CardType />;
  }

  return <div />;
};

export { renderBankIcon, renderCardTypeIcon, renderIcon };
